module.exports = __webpack_public_path__ + "static/media/backIcon.16632e4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/backIcon.png
// module id = 40
// module chunks = 0